<template>
  <b-col sm="12" md="3" class="h-100">
    <b-overlay class="h-100" :show="show">
      <b-card :body-class="['d-flex flex-column',textAlign]" class="card-responsive h-100">
        <b-card-title>
          <div class="mb-5 d-flex">{{ t("Login") }}</div>

          <auth-nav></auth-nav>
        </b-card-title>

        <div class="flex-grow-1 d-flex flex-column justify-content-between pt-5">
          <b-form id="login" @submit.prevent="submit">
            <b-form-group
                :description="t('Enter your serial number that you received from HIRO (10 digits)')">
              <b-input-group>
                <b-input-group-prepend class="icon">
                  <i-person width="1.5em" height="1.5em"></i-person>
                </b-input-group-prepend>

                <b-form-input size="sm" required name="serial_number" :placeholder="t('Serial number')"
                              type="text"></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group class="mb-2"
                          :description="t('Enter your password that you received in the same message from HIRO (4 digits)')">
              <b-input-group>
                <b-input-group-prepend class="icon">
                  <i-lock width="1.5em" height="1.5em"></i-lock>
                </b-input-group-prepend>

                <b-form-input size="sm"
                              required
                              name="password"
                              type="password"
                              :placeholder="t('Password')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <small class="font-weight-bolder">
              {{ t('In case you lost your HIRO\'s message please click here ') }}
              <a v-b-modal:reset-password href="#">{{ t('reset password') }}</a>
            </small>
          </b-form>

          <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="d-inline">
              <b-button form="login" type="submit" class="bg-grad" pill block>{{ t('Login') }}</b-button>
              <small class="font-weight-light">{{
                  t('You are not subscribed and want to create an EHR?')
                }}
                <router-link :to="{name: 'sign-up'}">{{ t('Sign up') }}</router-link>
              </small>
            </div>
          </div>
        </div>
      </b-card>
    </b-overlay>

    <b-modal id="reset-password" :title="t('reset password')" scrollable centered title-class="text-capitalize"
             @hide="hide"
             @close="hide"
             header-class="pl-4"
             footer-class="justify-content-center"
             content-class="border-radius-1">
      <b-form id="reset-password-form" @submit.prevent="resetPassword">
        <b-form-group>
          <b-input-group>
            <b-form-input size="sm" name="mobile" type="tel"
                          required
                          v-model="reset.phone"
                          :placeholder="t('Mobile number') + ' *'"></b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group
            :description="t('Please enter your mobile number and date of birth as it is written on your ID and you will receive the message.')">
          <b-input-group>
            <b-select size="sm" v-model="year" required>
              <b-select-option :value="null" disabled>{{ t('Year') }} *</b-select-option>
              <b-select-option v-for="year in YEARS" :value="year" :key="year">
                {{ year }}
              </b-select-option>
            </b-select>

            <b-select class="mx-2" size="sm" v-model="month" required>
              <b-select-option :value="null" disabled>{{ t('Month') }} *</b-select-option>
              <b-select-option v-for="month in MONTHS" :value="month" :key="month">
                {{ month }}
              </b-select-option>
            </b-select>

            <b-select size="sm" v-model="day" required>
              <b-select-option :value="null" disabled>{{ t('Day') }} *</b-select-option>
              <b-select-option v-for="day in DAYS" :value="day" :key="day">
                {{ day }}
              </b-select-option>
            </b-select>
          </b-input-group>
        </b-form-group>
      </b-form>

      <template v-slot:modal-footer="{cancel}">
        <b-button @click="cancel" class="mx-2 px-4" pill variant="secondary">{{ t('Cancel') }}</b-button>
        <b-button type="submit" form="reset-password-form" class="mx-2 px-4" pill variant="primary">
          {{ t('Submit') }}
        </b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>
import IPerson from "../../components/Icons/IPerson";
import ILock from "../../components/Icons/ILock";
import AuthNav from "../../components/Navs/AuthNav";

export default {
  name: "Login",
  components: {
    IPerson,
    ILock,
    AuthNav
  },
  inject: ['patientRepo', 'localStorageRepo'],
  data: () => ({
    show: false,
    year: null,
    day: null,
    month: null,
    reset: {
      phone: '',
    },
    MONTHS: (new Array(12)).fill(0).map((_, i) => i + 1),
    YEARS: (new Array((new Date().getFullYear()) - 1930)).fill(0).map((_, i) => (1930 + i + 1)),
  }),
  computed: {
    DAYS() {
      if (this.month) {
        if (+this.month <= 7) {
          if (+this.month % 2 === 1) {
            return (new Array(31)).fill(0).map((_, i) => i + 1);
          } else {
            return (new Array(30)).fill(0).map((_, i) => i + 1);
          }
        } else {
          if (+this.month % 2 === 0) {
            return (new Array(31)).fill(0).map((_, i) => i + 1);
          } else {
            return (new Array(30)).fill(0).map((_, i) => i + 1);
          }
        }
      } else {
        return []
      }
    },
    textAlign() {
      return this.$translate.lang === 'en' ? 'text-left' : 'text-right'
    }
  },
  methods: {
    submit(evt) {
      const formData = new FormData(evt.target);
      this.show = true;

      this.patientRepo.login(formData)
          .then(res => {
            this.patientRepo.dataSource.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
            this.localStorageRepo.setUser(res.data);
            if (!res.last_login) {
              if (!res.added_by) {
                this.$router.push({
                  name: 'guide',
                  query: {
                    back: {
                      name: 'health care providers',
                      query: {pay_alert: true, back: {name: 'consultations'}}
                    }
                  }
                })
              } else {
                this.$router.push({
                  name: 'guide',
                  query: {back: {name: 'consultations'}}
                })
              }
            } else {
              this.$router.push({name: 'consultations'});
            }
          })
          .catch(err => {
            this.$handleError(err);
            this.show = false
          })
    },

    hide() {
      this.day = this.year = this.month = this.reset.phone = null;
    },

    resetPassword() {
      this.reset.birthDate = `${this.year}-${this.month}-${this.day}`;

      this.patientRepo.resetPassword(this.reset)
          .then(({message}) => {
            this.$swal.fire({
              icon: 'success',
              text: message
            })
          })
          .catch(err => this.$handleError(err))
          .finally(() => this.$bvModal.hide('reset-password'));
    }
  },
}
</script>

<style scoped>
.icon {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
  padding: .22rem !important
}

.input-group > .form-control:not(:first-child), .input-group > .custom-select:not(:first-child) {
  border-top-left-radius: .2rem;
  border-bottom-left-radius: .2rem;
}
</style>
